var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showPlayer)?_c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"player-container portrait plyr--video",class:_vm.containerClass,attrs:{"id":"playerContainer"}},[_c('Player',{ref:"player",on:{"canplay":_vm.handleCanplay}}),_vm._v(" "),(_vm.adEnabled && _vm.canplay)?_c('AdContainer'):_vm._e()],1)]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-297b1455","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 